import React, { useState, useEffect } from 'react';
import { X, Send, PhoneCall } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Card, CardContent } from './ui/card';

const QuoteModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({ name: '', phone: '', email: '', notes: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.phone || !formData.email) return;
    console.log('Quote form submitted:', formData);
    alert('Enquiry sent! We\'ll contact you within 24 hours.');
    setFormData({ name: '', phone: '', email: '', notes: '' });
    onClose();
  };

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  useEffect(() => {
    if (!isOpen) return;
    const onKey = e => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-testid="quote-modal">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose}></div>

      <Card className="relative w-full max-w-2xl max-h-[90vh] overflow-y-auto border-2 border-rose-500/30 shadow-2xl">
        <CardContent className="p-0">
          <div className="bg-pink-500 p-6 relative">
            <button onClick={onClose} className="absolute top-4 right-4 p-2 rounded-full bg-white/20 hover:bg-white/30 transition-all duration-200" data-testid="modal-close-btn">
              <X className="w-5 h-5 text-white" />
            </button>
            <div className="pr-12">
              <div className="inline-block px-4 py-1 bg-white/20 rounded-full text-sm font-bold mb-3 text-white">
                ENQUIRE NOW
              </div>
              <h2 className="text-3xl md:text-4xl font-bold mb-2 text-white">Book Your Party</h2>
              <p className="text-lg text-pink-100">Melbourne's #1 rated entertainment agency</p>
            </div>
          </div>

          <div className="p-6 sm:p-8">
            <form onSubmit={handleSubmit} className="space-y-5">
              <div className="grid sm:grid-cols-2 gap-5">
                <div>
                  <label className="block text-sm font-semibold text-gray-900 mb-2">Your Name *</label>
                  <Input name="name" value={formData.name} onChange={handleChange} placeholder="John Smith" required className="h-12 border-gray-300 focus:border-pink-500" />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-900 mb-2">Phone *</label>
                  <Input name="phone" type="tel" value={formData.phone} onChange={handleChange} placeholder="04XX XXX XXX" required className="h-12 border-gray-300 focus:border-rose-500" />
                </div>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-900 mb-2">Email *</label>
                <Input name="email" type="email" value={formData.email} onChange={handleChange} placeholder="john@example.com" required className="h-12 border-gray-300 focus:border-rose-500" />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-900 mb-2">Event Details</label>
                <Textarea name="notes" value={formData.notes} onChange={handleChange} placeholder="Tell us about your event... (date, guests, what you're after)" rows={4} className="resize-none border-gray-300" />
              </div>
              <div className="p-4 rounded-lg bg-rose-50 border border-rose-200">
                <div className="flex items-start space-x-3">
                  <PhoneCall className="w-5 h-5 text-rose-600 mt-0.5" />
                  <div>
                    <p className="font-semibold text-rose-900">Fast Response Guaranteed</p>
                    <p className="text-sm text-gray-600">We'll contact you within 24 hours with all the details</p>
                  </div>
                </div>
              </div>
              <Button type="submit" size="lg" className="w-full h-14 text-lg bg-rose-600 hover:bg-rose-700 text-white font-bold transition-all duration-200 hover:scale-105 shadow-lg" data-testid="modal-submit-btn">
                <Send className="w-5 h-5 mr-2" />
                Send Enquiry
              </Button>
              <p className="text-xs text-gray-500 text-center">We'll get back to you within 24 hours. No spam, ever.</p>
            </form>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default QuoteModal;
